// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inpustyle[data-v-3514fe94]{width:400px}.addbut[data-v-3514fe94]{margin-left:20px}.headebut[data-v-3514fe94]{width:100%;margin-bottom:20px;box-sizing:border-box}.tableBox[data-v-3514fe94]{height:calc(100% - 260px)}.colorStyle[data-v-3514fe94]{color:red}.mdTitName[data-v-3514fe94]{height:24px;border:1px solid #d7d7d7;text-align:center;min-width:100px}", ""]);
// Exports
module.exports = exports;
